import { createAsyncThunk } from "@reduxjs/toolkit";
import apiRequest from "../../../services/api";

/* Survey Questions */
export const fetchSurveyQuestions = createAsyncThunk(
  "programs/fetch-survey-questions",
  async (body) => {
    let query = {
      page: body.page ? body.page : 1,
      page_size: body.page_size ? body.page_size : 10,
    };
    if (body.search) {
      query.search = body.search;
    }
    if (body.orderBy) {
      query.ordering = body.orderBy;
    }
    const surveyQuestions = await apiRequest.get(
      `v2/programs/survey/questions`,
      {
        headers: { organization: body.userOrganization.org_id },
        params: query,
      }
    );
    return surveyQuestions.data;
  }
);

export const fetchSurveyQuestionDetails = createAsyncThunk(
  "programs/fetch-survey-question-details",
  async (body) => {
    let query = {
      page: body.page ? body.page : 1,
      page_size: body.page_size ? body.page_size : 10,
    };
    if (body.search) {
      query.search = body.search;
    }
    const surveyQuestions = await apiRequest.get(
      `v2/programs/survey/questions/${body.id}`,
      {
        headers: { organization: body.userOrganization.org_id },
        params: query,
      }
    );
    return surveyQuestions.data;
  }
);

export const createSurveyQuestion = createAsyncThunk(
  "programs/create-survey-questions",
  async (body) => {
    try {
      const surveyQuestions = await apiRequest.post(
        `v2/programs/survey/questions/`,
        body.data,
        {
          headers: { organization: body.userOrganization.org_id },
        }
      );
      return surveyQuestions.data;
    } catch (error) {
      throw new Error(Object.values(error.response.data));
    }
  }
);

export const editSurveyQuestion = createAsyncThunk(
  "programs/edit-survey-questions",
  async (body) => {
    try {
      const surveyQuestions = await apiRequest.put(
        `v2/programs/survey/questions/${body.data.question_id}`,
        body.data,
        {
          headers: { organization: body.userOrganization.org_id },
        }
      );
      return surveyQuestions.data;
    } catch (error) {
      throw new Error(Object.values(error.response.data));
    }
  }
);

export const deleteSurveyQuestion = createAsyncThunk(
  "programs/edit-survey-questions",
  async (body) => {
    const surveyQuestions = await apiRequest.delete(
      `v2/programs/survey/questions/${body.id}/`,
      {
        headers: { organization: body.userOrganization.org_id },
      }
    );
    return surveyQuestions.data;
  }
);

/* Survey Module */
export const fetchSurveyModules = createAsyncThunk(
  "programs/fetch-survey-modules/",
  async (body) => {
    let query = {
      page: body.page ? body.page : 1,
      page_size: body.page_size ? body.page_size : 10,
    };
    if (body.search) {
      query.search = body.search;
    }
    if (body.status) {
      query.status = body.status === "All" ? "" : body.status;
    }
    const surveyModules = await apiRequest.get(`v2/programs/survey/modules`, {
      headers: { organization: body.userOrganization.org_id },
      params: query,
    });
    return surveyModules.data;
  }
);

export const createSurveyModule = createAsyncThunk(
  "programs/create-survey-module",
  async (body) => {
    const surveyQuestions = await apiRequest.post(
      `v2/programs/survey/modules/`,
      body.data,
      {
        headers: { organization: body.userOrganization.org_id },
      }
    );
    return surveyQuestions.data;
  }
);
export const deleteSurveyModule = createAsyncThunk(
  "programs/create-survey-module",
  async (body) => {
    try {
      const surveyQuestions = await apiRequest.delete(
        `v2/programs/survey/modules/${body.id}`,
        {
          headers: { organization: body.userOrganization.org_id },
        }
      );
      return surveyQuestions.data;
    } catch (error) {
      throw new Error(Object.values(error.response.data));
    }
  }
);

export const assignSurveyModule = createAsyncThunk(
  "programs/assign-survey-module",
  async (body) => {
    try {
      const surveyQuestions = await apiRequest.post(
        `v2/programs/survey/assignments/`,
        body.data,
        {
          headers: { organization: body.userOrganization.org_id },
        }
      );
      return surveyQuestions.data;
    } catch (error) {
      throw new Error(Object.values(error.response.data));
    }
  }
);

/* Survey Assignment */
export const fetchSurveyAssignments = createAsyncThunk(
  "programs/fetch-survey-assignments",
  async (body) => {
    let query = {
      page: body.page ? body.page : 1,
      page_size: body.page_size ? body.page_size : 10,
    };
    if (body.search) {
      query.search = body.search;
    }
    const surveyAssignments = await apiRequest.get(
      `v2/programs/survey/assignments`,
      {
        headers: { organization: body.userOrganization.org_id },
        params: query,
      }
    );
    return surveyAssignments.data;
  }
);

export const fetchSurveyAssignmentDetails = createAsyncThunk(
  "programs/fetch-survey-assignment-details",
  async (body) => {
    let query = {
      page: body.page ? body.page : 1,
      page_size: body.page_size ? body.page_size : 10,
    };
    if (body.search) {
      query.search = body.search;
    }
    const surveyAssignments = await apiRequest.get(
      `v2/programs/survey/assignments/${body.id}`,
      {
        headers: { organization: body.userOrganization.org_id },
        params: query,
      }
    );
    return surveyAssignments.data;
  }
);

export const fetchProgramAssignmentSurvey = createAsyncThunk(
  "programs/fetch_program_assignment_survey",
  async (body) => {
    let query = {
      page: body.page ? body.page : 1,
      page_size: body.page_size ? body.page_size : 10,
    };
    if (body.search) {
      query.search = body.search;
    }
    if (body.status) {
      query.status = body.status === "All" ? "" : body.status;
    }
    if (body.programName) {
      query.program__title = body.programName;
    }
    if (body.program) {
      query.program = body.program;
    }
    // organization, clinic, role, user_type
    if (body.organization) {
      query.organization = body.organization;
    }
    if (body.clinic) {
      query.clinic = body.clinic;
    }
    if (body.role) {
      query.role = body.role;
    }
    if (body.userType) {
      query.user_type = body.userType;
    }
    if (body.orderBy) {
      query.ordering = body.orderBy;
    }
    if (body.group) {
      query.group = body.group;
    }
    if (body.user) {
      query.user_email = body.user;
    }
    const programAssignment = await apiRequest.get(`v2/programs/assignments/`, {
      headers: { organization: body.userOrganization.org_id },
      params: query,
    });
    return programAssignment.data;
  }
);

export const deleteProgramAssignmentSurvey = createAsyncThunk(
  "survey/delete_program_assignment",
  async (body) => {
    const deleteProgramAssignment = await apiRequest.delete(
      `v2/programs/assignments/${body.id}/`,
      {
        headers: { organization: body.userOrganization.org_id },
      }
    );
    return deleteProgramAssignment.data;
  }
);
